module.exports = __webpack_public_path__ + "img/logo.bb7d57f0.svg";